import { Box } from '@/ui/primitives';
import { r, s } from '../../theme/tokens';
import { LastUpdated } from './LastUpdated';
import type { SxProps, Theme } from '@/ui/primitives';
import type { ReactElement } from 'react';

type ServerDataTableFrameProps = {
  containerStyles: Array<Exclude<SxProps<Theme>, readonly unknown[] | boolean | null | undefined>>;
  dataError: string | null;
  dataState: string;
  dataTable: ReactElement | null;
  isFetching: boolean;
  lastUpdatedAt: number | null;
  placeholder: ReactElement | null;
  resolvedHeight?: number;
  showLastUpdated: boolean;
  showPlaceholderGrid: boolean;
  showSkeletonGrid: boolean;
  skeleton: ReactElement | null;
};

export const ServerDataTableFrame = ({
  containerStyles,
  dataError,
  dataState,
  dataTable,
  isFetching,
  lastUpdatedAt,
  placeholder,
  resolvedHeight,
  showLastUpdated,
  showPlaceholderGrid,
  showSkeletonGrid,
  skeleton,
}: ServerDataTableFrameProps): ReactElement => (
  <Box sx={{ width: '100%', minWidth: 0 }}>
    <Box
      data-testid="grid-ready"
      data-state={dataState}
      data-error={dataError ?? ''}
      sx={{ display: 'none' }}
    />
    <Box
      data-state={dataState}
      data-fetching={isFetching ? 'true' : 'false'}
      sx={[
        {
          height: resolvedHeight ?? 'auto',
          width: '100%',
          minWidth: 0,
          backgroundColor: 'background.paper',
          borderRadius: r('none'),
          boxShadow: 'none',
          boxSizing: 'border-box',
          position: 'relative',
          overflow: 'hidden',
          overflowAnchor: 'none',
          '& .MuiDataGrid-root': { border: 'none' },
        },
        ...containerStyles,
      ]}
    >
      {showSkeletonGrid ? skeleton : showPlaceholderGrid ? placeholder : dataTable}
    </Box>
    {showLastUpdated ? (
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', px: s('sm'), pt: s('sm') }}>
        <LastUpdated timestamp={lastUpdatedAt} />
      </Box>
    ) : null}
  </Box>
);
